import { memo } from "react";
import "./SmartDPReasons.scss";
import ReasonToBookBlockContainer from "app/pages/.shared/ReasonsToBook/ReasonToBookBlock/ReasonToBookBlockContainer";

const SmartDPReasons = () => {
	return (
		<div className="sdp-reasons">
			<ReasonToBookBlockContainer titleHeadingLevel={2} />
		</div>
	);
};

export default memo(SmartDPReasons);
